import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import type SvgIcon from '@mui/material/SvgIcon';
import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/system';
import type { FunctionComponent } from 'react';

import { Headline } from '../Typography';

const StyledButton = styled(Button)(() => ({
    '&, &:hover': { border: 'none', boxShadow: 'unset' },
}));

type TextButtonWithIconProps = {
    readonly backgroundColor: MuiTypographyProps['color'];
    readonly Icon: typeof SvgIcon;
    readonly label: string;
    readonly onIconClick: () => void;
    readonly onLabelClick: () => void;
    readonly textColor: MuiTypographyProps['color'];
};
export const TextButtonWithIcon: FunctionComponent<TextButtonWithIconProps> = ({
    backgroundColor,
    Icon,
    label,
    onIconClick,
    onLabelClick,
    textColor,
}) => (
    <ButtonGroup
        disableElevation={true}
        sx={{
            borderRadius: '4px',
            color: textColor,
            display: 'flex',
            gap: '2px',
            overflow: 'hidden',
        }}
    >
        <StyledButton
            sx={{
                '& > *': { overflow: 'hidden', textOverflow: 'ellipsis' },
                '&, &:hover': { backgroundColor },
                color: textColor,
                overflow: 'hidden',
                padding: '6px 12px',
                whiteSpace: 'nowrap',
            }}
            variant="contained"
            onClick={onLabelClick}
        >
            <Headline variant="h6">{label}</Headline>
        </StyledButton>
        <StyledButton
            sx={{
                '&, &:hover': { backgroundColor },
                display: 'grid',
                height: '36px',
                placeItems: 'center',
                width: '36px',
            }}
            onClick={onIconClick}
        >
            <Icon sx={{ fill: textColor }} />
        </StyledButton>
    </ButtonGroup>
);
